import(/* webpackMode: "eager", webpackExports: ["ArtistDetail"] */ "/workspace/src/components/artists/artist-detail.tsx");
